module.exports = __webpack_public_path__ + "static/scale-model-of-state-historical-museum-of-iowa-in-des-moines-iowa-e2e40b57e018b0020ff4e02b4405233c.png";